import { CalendarEvent } from "./CalendarEvent";
import { ConferenceRoom } from "./ConferenceRoom";

export class CalendarEvents {
  constructor(
    public readonly conferenceRoom: ConferenceRoom,
    public readonly events: CalendarEvent[]
  ) {}
}
